"use strict";

require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Step1Selectors = {
  FORM: "#step1_form",
  CLEAR_ALL_PRODUCTS: '#clear_all',
  RETURN_TO_SHOP_BUTTON: 'button.return-to-shop-button',
  PRODUCT_AND_OFFER_CART: {
    CONTAINER: '.js_product_row_cart_and_offer',
    TOTAL: '.js_product_cart_and_offer_total'
  },
  PRODUCT: {
    CONTAINER: '.js_product_row',
    REMOVE: '.js_product_remove',
    QUANTITY: '.js_product_quantity',
    UNIT_WEIGHT: '[data-unit-row-weight]',
    WEIGHT: '.js_product_weight',
    LENGTH: '.js_product_length',
    TOTAL: '.js_product_total',
    QUANTITY_CONTROL_INCREASE: '.product-input-control-plus',
    QUANTITY_CONTROL_DECREASE: '.product-input-control-minus'
  },
  OFFER: {
    OFFER_CLEAR_ALL: '#clear_all_offer',
    OFFER_CONTAINER: '.js_product_offer_row',
    OFFER_REMOVE: '.js_product_offer_remove',
    OFFER_QUANTITY: '.js_product_offer_quantity',
    OFFER_TOTAL: '.js_product_offer_total',
    OFFER_QUANTITY_CONTROL_INCREASE: '.offer-input-control-plus',
    OFFER_QUANTITY_CONTROL_DECREASE: '.offer-input-control-minus'
  },
  SUMMARY_PANEL: {
    TOTAL_QUANTITIES: '.total-quantities',
    PRODS_QUANTITY: '#products-quantity',
    TOTAL: '.total-price',
    TOTAL_PLUS_DELIVERY: '.js_summary_order',
    TOTAL_WEIGHT: '.total-weight',
    TOTAL_LENGTH: '.total-length',
    DELIVERY_MIN: '#js_sum_delivery_order'
  }
};